import {
	GenericTableSectionHeaderRow,
	GenericTableSectionHeaderCell,
} from '@/libraries/design/patterns/table/src/generic-table-header-row.tsx';

export interface UniformTableHeaderRowProps {
	/**
	 * Label text for the section header row.
	 */
	text?: string;
}

const UniformTableHeaderRow = ({ text }: UniformTableHeaderRowProps) => {
	return (
		<GenericTableSectionHeaderRow>
			<GenericTableSectionHeaderCell colSpan={999}>{text}</GenericTableSectionHeaderCell>
		</GenericTableSectionHeaderRow>
	);
};

export default UniformTableHeaderRow;
